var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleTextAlignLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#323C47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41667 3.33333C3.05 3.33333 2.75 3.03333 2.75 2.66667C2.75 2.3 3.05 2 3.41667 2H14.0833C14.45 2 14.75 2.3 14.75 2.66667C14.75 3.03333 14.45 3.33333 14.0833 3.33333H3.41667ZM10.0833 4.66667H3.41667C3.05 4.66667 2.75 4.96667 2.75 5.33333C2.75 5.7 3.05 6 3.41667 6H10.0833C10.45 6 10.75 5.7 10.75 5.33333C10.75 4.96667 10.45 4.66667 10.0833 4.66667ZM10.0833 10H3.41667C3.05 10 2.75 10.3 2.75 10.6667C2.75 11.0333 3.05 11.3333 3.41667 11.3333H10.0833C10.45 11.3333 10.75 11.0333 10.75 10.6667C10.75 10.3 10.45 10 10.0833 10ZM14.0833 8.66667H3.41667C3.05 8.66667 2.75 8.36667 2.75 8C2.75 7.63333 3.05 7.33333 3.41667 7.33333H14.0833C14.45 7.33333 14.75 7.63333 14.75 8C14.75 8.36667 14.45 8.66667 14.0833 8.66667ZM3.41667 14H14.0833C14.45 14 14.75 13.7 14.75 13.3333C14.75 12.9667 14.45 12.6667 14.0833 12.6667H3.41667C3.05 12.6667 2.75 12.9667 2.75 13.3333C2.75 13.7 3.05 14 3.41667 14Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleTextAlignLeft);
export default __webpack_public_path__ + "static/media/styleTextAlignLeft.a5db3985.svg";
export { ForwardRef as ReactComponent };